import { useState } from "react";
import '@iconscout/unicons/css/line.css';

import "./css/RedirectPage.css";
import logo from "../assets/logo.svg";
import TenantSelectModal from "../components/TenantSelectModal";
import Header from "../components/Header";

const RedirectPage = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [tenantOptions, setTenantOptions] = useState([]);
  const [showTenantSelect, setShowTenantSelect] = useState(false);


  const handleLookup = async (e) => {
    e.preventDefault();
    setError("");


    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/lookup-tenants`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      if (res.status === 404) {
        setError("Email not found.");
        return;
      }
      if (!res.ok) {
        throw new Error("Lookup failed");
      }
      const tenants = await res.json();
      if (!tenants.length) {
        setError("No tenant associated with this email.");
        return;
      }
      if (tenants.length === 1) {
        redirectToTenant(tenants[0]);
      } else {
        setTenantOptions(tenants);
        setShowTenantSelect(true);
      }
    } catch (err) {
      console.error("Lookup error:", err);
      setError("Could not retrieve tenant list.");
    }
  };

  const redirectToTenant = (tenant) => {
    if (!tenant?.subdomain) {
      setError("Invalid tenant information.");
      return;
    }
    let domain = tenant.subdomain;
    //check db and look if the domain contains the "." indicating it is a tenant domain.
    console.log(domain)
    if (!domain.includes(".")) {
      domain = `${domain}.daquma.ai`;
    }
    window.location.href = `https://${domain}/`;
  };

  return (
    <div className="landing-page">
    <Header/>
      <div className="redirect-page">
        <form onSubmit={handleLookup}>
    
          <div className="logo-banner">
          <img src={logo} alt="Logo" className="logo" />
          </div>


          <div className="form-group">
            <label htmlFor="email">DAQUMA AI - Login</label>
            <div className="input-wrapper">
              <i className="uil uil-envelope-alt email-icon" />
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>
          <button type="submit">Continue</button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>


      {showTenantSelect && (
        <TenantSelectModal
          tenantOptions={tenantOptions}
          onSelect={(tenant) => {
            redirectToTenant(tenant);
            setShowTenantSelect(false);
          }}
          onClose={() => setShowTenantSelect(false)}
        />
      )}
    </div>
  );
};

export default RedirectPage;
